// extracted by mini-css-extract-plugin
export default {"subtitle":"SLHeader_subtitle__98ZnR","root":"SLHeader_root__9ZO3-","title":"SLHeader_title__tTdKP","content":"SLHeader_content__K0d2I","status":"SLHeader_status__MHwug"};